import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createVNode as _createVNode, vShow as _vShow, withModifiers as _withModifiers, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  class: "cinema__empty"
};
const _hoisted_2 = {
  class: "cinema__empty-content"
};
const _hoisted_3 = {
  key: 0,
  class: "loading"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", null, "资源匹配中...", -1);
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "首次可能需要3~5分钟", -1);
const _hoisted_7 = {
  key: 0,
  class: "flowhub"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = {
  class: "button-box"
};
const _hoisted_10 = {
  class: "tips"
};
const _hoisted_11 = {
  key: 1,
  class: "default"
};
const _hoisted_12 = ["src"];
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h2", null, "暂无资源", -1);
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", null, "将设备上的视频添加到个人片库，可帮您在公开网络上检索媒体信息", -1);
const _hoisted_15 = {
  class: "button-box"
};
const _hoisted_16 = {
  class: "tips"
};
const _hoisted_17 = {
  key: 2,
  class: "no-resource"
};
const _hoisted_18 = ["src"];
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h2", null, "暂未匹配到结果", -1);
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", null, "请尝试手动选择其他路径或添加视频到现有路径中后从右上角菜单中选择刷新", -1);
const _hoisted_21 = {
  key: 3,
  class: "loading-layout"
};
const _hoisted_22 = {
  class: "loading-area"
};
import empty from '@shared/assets/img/cinema-empty.png';
import emptyBox from '@shared/assets/img/empty-box.png';
import { useDeviceStore } from '@remote/store/device';
import { IconLoading2, IconHelp } from '@xunlei/thunder-icon-vue';
import { openCinemaSourceSetting } from '@remote/utils/dialog';
import { flowHubInstance } from '@remote/api/flowhub';
import { computed } from 'vue';
import { useToggleTips } from '@shared/composable/base';
import { stat } from '@remote/utils/stat';
export default /*#__PURE__*/_defineComponent({
  __name: 'CinemaEmpty',
  props: {
    hasListInit: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const props = __props;
    const deviceStore = useDeviceStore();
    const trackers = computed(() => {
      var _flowHubInstance$slot;
      return (_flowHubInstance$slot = flowHubInstance.slotResult.value['POSITION_CINEMA_EMPTY']) === null || _flowHubInstance$slot === void 0 || (_flowHubInstance$slot = _flowHubInstance$slot.slots) === null || _flowHubInstance$slot === void 0 || (_flowHubInstance$slot = _flowHubInstance$slot[0]) === null || _flowHubInstance$slot === void 0 ? void 0 : _flowHubInstance$slot.trackers;
    });
    const reportShowURL = computed(() => {
      if (Array.isArray(trackers.value)) {
        var _trackers$value$find;
        const url = (_trackers$value$find = trackers.value.find(tracker => tracker.event === 'EVENT_IMPRESSION')) === null || _trackers$value$find === void 0 ? void 0 : _trackers$value$find.url;
        if (url) {
          return url;
        }
      }
      return null;
    });
    const reportClickURL = computed(() => {
      if (Array.isArray(trackers.value)) {
        var _trackers$value$find2;
        const url = (_trackers$value$find2 = trackers.value.find(tracker => tracker.event === 'EVENT_CLICK')) === null || _trackers$value$find2 === void 0 ? void 0 : _trackers$value$find2.url;
        if (url) return url;
      }
      return null;
    });
    const guideAssets = computed(() => {
      var _flowHubInstance$slot2;
      return (_flowHubInstance$slot2 = flowHubInstance.slotResult.value['POSITION_CINEMA_EMPTY']) === null || _flowHubInstance$slot2 === void 0 || (_flowHubInstance$slot2 = _flowHubInstance$slot2.slots) === null || _flowHubInstance$slot2 === void 0 || (_flowHubInstance$slot2 = _flowHubInstance$slot2[0]) === null || _flowHubInstance$slot2 === void 0 || (_flowHubInstance$slot2 = _flowHubInstance$slot2.native) === null || _flowHubInstance$slot2 === void 0 ? void 0 : _flowHubInstance$slot2.assets;
    });
    const title = computed(() => {
      var _guideAssets$value;
      return (_guideAssets$value = guideAssets.value) === null || _guideAssets$value === void 0 || (_guideAssets$value = _guideAssets$value.title) === null || _guideAssets$value === void 0 || (_guideAssets$value = _guideAssets$value.text) === null || _guideAssets$value === void 0 ? void 0 : _guideAssets$value.value;
    });
    const image = computed(() => {
      var _guideAssets$value2;
      return (_guideAssets$value2 = guideAssets.value) === null || _guideAssets$value2 === void 0 || (_guideAssets$value2 = _guideAssets$value2.image) === null || _guideAssets$value2 === void 0 || (_guideAssets$value2 = _guideAssets$value2.img) === null || _guideAssets$value2 === void 0 ? void 0 : _guideAssets$value2.url;
    });
    const desc = computed(() => {
      var _guideAssets$value3;
      return (_guideAssets$value3 = guideAssets.value) === null || _guideAssets$value3 === void 0 || (_guideAssets$value3 = _guideAssets$value3.desc) === null || _guideAssets$value3 === void 0 || (_guideAssets$value3 = _guideAssets$value3.text) === null || _guideAssets$value3 === void 0 ? void 0 : _guideAssets$value3.value;
    });
    const cta = computed(() => {
      var _guideAssets$value4;
      return (_guideAssets$value4 = guideAssets.value) === null || _guideAssets$value4 === void 0 || (_guideAssets$value4 = _guideAssets$value4.cta) === null || _guideAssets$value4 === void 0 || (_guideAssets$value4 = _guideAssets$value4.text) === null || _guideAssets$value4 === void 0 ? void 0 : _guideAssets$value4.value;
    });
    const onSettingSource = () => {
      if (reportClickURL.value) {
        flowHubInstance.reportFlowHub(reportClickURL.value, {});
      }
      openCinemaSourceSetting({
        from: 'blank_channel'
      });
    };
    const onImpression = () => {
      if (reportShowURL.value) {
        flowHubInstance.reportFlowHub(reportShowURL.value, {});
      }
    };
    const {
      isShow: isExplainShow,
      show: showExplain
    } = useToggleTips();
    return (_ctx, _cache) => {
      var _unref$currentNFOInst, _unref$currentNFOInst2, _title$value, _desc$value, _image$value, _cta$value, _unref$currentNFOInst3;
      const _directive_see = _resolveDirective("see");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_unref$currentNFOInst = _unref(deviceStore).currentNFOInstance) !== null && _unref$currentNFOInst !== void 0 && _unref$currentNFOInst.isScraping ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("img", {
        src: _unref(empty),
        draggable: "false"
      }, null, 8, _hoisted_4), _hoisted_5, _hoisted_6])) : (_unref$currentNFOInst2 = _unref(deviceStore).currentNFOInstance) !== null && _unref$currentNFOInst2 !== void 0 && _unref$currentNFOInst2.hasInitLocalState && !_unref(deviceStore).currentNFOInstance.hasInitCinema ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [guideAssets.value ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("h2", null, _toDisplayString((_title$value = title.value) !== null && _title$value !== void 0 ? _title$value : '暂无资源'), 1), _createElementVNode("p", null, _toDisplayString((_desc$value = desc.value) !== null && _desc$value !== void 0 ? _desc$value : '将设备上的视频添加到个人片库，可帮您在公开网络上检索媒体信息'), 1), _createElementVNode("img", {
        src: (_image$value = image.value) !== null && _image$value !== void 0 ? _image$value : _unref(empty),
        draggable: "false"
      }, null, 8, _hoisted_8), _createElementVNode("div", _hoisted_9, [_createElementVNode("button", {
        class: "button-base",
        onClick: onSettingSource
      }, _toDisplayString((_cta$value = cta.value) !== null && _cta$value !== void 0 ? _cta$value : '手动选择'), 1), _withDirectives((_openBlock(), _createElementBlock("button", {
        class: "button-base primary-button",
        onClick: _cache[0] || (_cache[0] = $event => {
          _unref(stat)({
            action: 'one_click_configuration_button_click'
          });
          _unref(deviceStore).currentNFOInstance.oneKeyConfigScrape();
        })
      }, [_createTextVNode(" 一键配置 ")])), [[_directive_see, () => _unref(stat)({
        action: 'one_click_configuration_button_show'
      })]])]), _createElementVNode("span", {
        class: "one-key-explain",
        onClick: _cache[1] || (_cache[1] = _withModifiers($event => _unref(showExplain)('click'), ["stop"])),
        onTouchstart: _cache[2] || (_cache[2] = _withModifiers($event => _unref(showExplain)('touch'), ["stop"]))
      }, [_createVNode(_unref(IconHelp), {
        width: "16",
        height: "16"
      }), _createTextVNode("配置说明 "), _withDirectives(_createElementVNode("span", _hoisted_10, " 选择「一键配置」会默认选择云盘缓存 & 迅雷下载 & 历史下载路径文件夹 目录下的视频进行匹配。您也可以手动选择其他文件夹。 ", 512), [[_vShow, _unref(isExplainShow)]])], 32)])), [[_directive_see, onImpression]]) : (_openBlock(), _createElementBlock("div", _hoisted_11, [_createElementVNode("img", {
        src: _unref(empty),
        draggable: "false"
      }, null, 8, _hoisted_12), _hoisted_13, _hoisted_14, _createElementVNode("div", _hoisted_15, [_createElementVNode("button", {
        class: "button-base",
        onClick: onSettingSource
      }, " 手动选择 "), _withDirectives((_openBlock(), _createElementBlock("button", {
        class: "button-base primary-button",
        onClick: _cache[3] || (_cache[3] = $event => {
          _unref(stat)({
            action: 'one_click_configuration_button_click'
          });
          _unref(deviceStore).currentNFOInstance.oneKeyConfigScrape();
        })
      }, [_createTextVNode(" 一键配置 ")])), [[_directive_see, () => _unref(stat)({
        action: 'one_click_configuration_button_show'
      })]])]), _createElementVNode("span", {
        class: "one-key-explain",
        onClick: _cache[4] || (_cache[4] = $event => _unref(showExplain)('click')),
        onTouchstart: _cache[5] || (_cache[5] = $event => _unref(showExplain)('touch'))
      }, [_createVNode(_unref(IconHelp), {
        width: "16",
        height: "16"
      }), _createTextVNode("配置说明 "), _withDirectives(_createElementVNode("span", _hoisted_16, " 选择「一键配置」会默认选择云盘缓存 & 迅雷下载 & 历史下载路径文件夹 目录下的视频进行匹配。您也可以手动选择其他文件夹。 ", 512), [[_vShow, _unref(isExplainShow)]])], 32)]))], 64)) : (_unref$currentNFOInst3 = _unref(deviceStore).currentNFOInstance) !== null && _unref$currentNFOInst3 !== void 0 && _unref$currentNFOInst3.hasInitLocalState && props.hasListInit ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_17, [_createElementVNode("img", {
        src: _unref(emptyBox),
        draggable: "false"
      }, null, 8, _hoisted_18), _hoisted_19, _hoisted_20, _createElementVNode("button", {
        class: "button-base primary-button",
        onClick: onSettingSource
      }, " 手动选择 ")])), [[_directive_see, () => _unref(stat)({
        action: 'local_empty_page_show'
      })]]) : (_openBlock(), _createElementBlock("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createVNode(_unref(IconLoading2), {
        width: "28",
        height: "28",
        class: "loading-spin"
      }), _createTextVNode(" 加载资源中 ")])]))])]);
    };
  }
});